module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "t-flex-grid"
  }, [_c('div', {
    staticClass: "t-flex-grid__item c-2d__perspective",
    attrs: {
      "id": "perspective"
    }
  }, [(_vm.touch) ? _c('canvas', {
    staticClass: "c-2d"
  }) : _vm._e(), _vm._v(" "), (_vm.touch) ? _c('div', {
    staticClass: "c-2d__main-image"
  }) : _vm._e(), _vm._v(" "), (!_vm.touch) ? _c('canvas', {
    staticClass: "c-2d",
    attrs: {
      "id": "canvas"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.touch) ? _c('div', {
    staticClass: "c-2d--dist",
    attrs: {
      "id": "overlay"
    }
  }) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "c-2d__svg c-2d__svg--right",
    attrs: {
      "version": "1.1",
      "baseProfile": "tiny",
      "id": "svg-circle-outer",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "561px",
      "height": "561px",
      "viewBox": "0 0 560 560",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "c-2d__loader",
    attrs: {
      "fill": "none",
      "cx": "280",
      "cy": "280",
      "r": "280",
      "stroke-dashoffset": "1759.292",
      "stroke-dasharray": "1759.292",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "c-2d__svg c-2d__svg--left",
    attrs: {
      "version": "1.1",
      "baseProfile": "tiny",
      "id": "svg-circle-outer-left",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "561px",
      "height": "561px",
      "viewBox": "0 0 560 560",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "c-2d__loader",
    attrs: {
      "fill": "none",
      "cx": "280",
      "cy": "280",
      "r": "280",
      "stroke-dashoffset": "1759.292",
      "stroke-dasharray": "1759.292",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "c-2d__svg c-2d__svg--inner c-2d__svg--right",
    attrs: {
      "version": "1.1",
      "baseProfile": "tiny",
      "id": "svg-circle-inner",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "561px",
      "height": "561px",
      "viewBox": "0 0 560 560",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "c-2d__loader",
    attrs: {
      "fill": "none",
      "cx": "280",
      "cy": "280",
      "r": "280",
      "stroke-dashoffset": "1759.292",
      "stroke-dasharray": "1759.292",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "c-2d__svg c-2d__svg--inner c-2d__svg--left",
    attrs: {
      "version": "1.1",
      "baseProfile": "tiny",
      "id": "svg-circle-inner-left",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "561px",
      "height": "561px",
      "viewBox": "0 0 560 560",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "c-2d__loader",
    attrs: {
      "fill": "none",
      "cx": "280",
      "cy": "280",
      "r": "280",
      "stroke-dashoffset": "1759.292",
      "stroke-dasharray": "1759.292",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-2d__mask"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "c-2d__page-btns"
  }, [_c('button', {
    staticClass: "c-2d__page-btn c-2d__page-btn--prev",
    on: {
      "click": function($event) {
        _vm.goPrevious()
      }
    }
  }, [_c('svg', {
    staticClass: "c-2d__svg-page",
    attrs: {
      "version": "1.1",
      "baseProfile": "tiny",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "39px",
      "height": "39px",
      "viewBox": "0 0 36 36",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "c-2d__page-circle",
    attrs: {
      "fill": "none",
      "cx": "18",
      "cy": "17",
      "r": "18",
      "stroke-dashoffset": "113.01",
      "stroke-dasharray": "113.01",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "c-2d__page-btn c-2d__page-btn--next",
    on: {
      "click": function($event) {
        _vm.goNext($event)
      }
    }
  }, [_c('svg', {
    staticClass: "c-2d__svg-page",
    attrs: {
      "version": "1.1",
      "baseProfile": "tiny",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "39px",
      "height": "39px",
      "viewBox": "0 0 36 36",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "c-2d__page-circle",
    attrs: {
      "fill": "none",
      "cx": "18",
      "cy": "17",
      "r": "18",
      "stroke-dashoffset": "113.01",
      "stroke-dasharray": "113.01",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-2d__pagination"
  }, [_c('span', {
    staticClass: "c-2d__page-number c-2d__page-number--edge",
    class: {
      'c-2d__page-number--active': _vm.currentIndex == 2, 'c-2d__page-number--inactive': _vm.currentIndex != 2
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-2d__page-number c-2d__page-number--center",
    class: {
      'c-2d__page-number--active': _vm.currentIndex == 0, 'c-2d__page-number--inactive': _vm.currentIndex != 0
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-2d__page-number c-2d__page-number--edge",
    class: {
      'c-2d__page-number--active': _vm.currentIndex == 1, 'c-2d__page-number--inactive': _vm.currentIndex != 1
    }
  })])]), _vm._v(" "), _c('router-link', {
    staticClass: "t-flex-grid__title",
    attrs: {
      "to": "/shop"
    }
  }, [_vm._v("EXPLORE OUR COLLECTION")]), _vm._v(" "), _c('span', {
    staticClass: "t-flex-grid__btn-mask"
  }), _vm._v(" "), _c('script', {
    attrs: {
      "id": "vs",
      "type": "f"
    }
  }, [_vm._v("\n            attribute vec2 position;\n            attribute vec2 texcoord;\n\n            uniform mat3 u_matrix;\n\n            varying vec2 v_texcoord;\n\n            void main() {\n                gl_Position = vec4(u_matrix * vec3(position, 1), 1);\n                v_texcoord = texcoord;\n            }\n        ")]), _vm._v(" "), _c('script', {
    attrs: {
      "id": "fs",
      "type": "f"
    }
  }, [_vm._v("\n            precision mediump float;\n\n            uniform vec2 u_mouse;\n\n            uniform sampler2D u_originalImage;\n            uniform sampler2D u_mapImage;\n\n            varying vec2 v_texcoord;\n\n            void main() {\n                vec4 depthDistortion = texture2D(u_mapImage, v_texcoord);\n                float parallaxMult = depthDistortion.r;\n\n                vec2 parallax = (u_mouse) * parallaxMult;\n\n                vec4 original = texture2D(u_originalImage, (v_texcoord + parallax));\n                gl_FragColor = original;\n            }\n        ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    staticClass: "c-2d__video",
    attrs: {
      "id": "video1",
      "muted": "muted",
      "loop": "",
      "autoplay": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "assets\\videos\\Comp 2_4.webm",
      "type": "video/webm"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-342a958c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThreeD.vue
// module id = 392
// module chunks = 0